import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import Heading from '../components/Heading'
import PageLayout from '../components/PageLayout'
import RadioInputButton from '../components/RadioInputButton'
import { AnswerType } from '../types'

export default function SingleChoiceQuestionPage({
  answers,
  subtitle,
  title,
  withLogin = false,
  onSubmit = () => {},
  preselectedValue,
  translationInterpolation,
}: {
  answers: AnswerType[]
  subtitle?: string
  title: string
  withLogin?: boolean
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void
  preselectedValue?: string
  /** Passed to `t()` for title/subtitle (e.g. `{{language}}`) */
  translationInterpolation?: Record<string, string>
}) {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()

    if (onSubmit) {
      onSubmit(event as unknown as React.FormEvent<HTMLFormElement>)
    }
    submit(event.currentTarget.form)
  }

  return (
    <PageLayout withLogin={withLogin}>
      <div className="shrink-0">
        <Heading
          subtitle={
            subtitle ? t(subtitle, translationInterpolation) : undefined
          }
          title={t(title, translationInterpolation)}
        />
      </div>

      <div className="flex grow flex-col justify-center">
        <Form className="space-y-4" method="post">
          {answers.map((answer) => (
            <RadioInputButton
              emoji={answer.emoji}
              name={t(title, {
                lng: 'en',
                ...translationInterpolation,
              })}
              key={t(answer.title)}
              onChange={handleChange}
              subtitle={answer.subtitle ? t(answer.subtitle) : undefined}
              title={t(answer.title)}
              value={
                answer.value ? t(answer.value) : t(answer.title, { lng: 'en' })
              }
              preselected={
                preselectedValue ? preselectedValue === answer.value : undefined
              }
            />
          ))}
        </Form>
      </div>
    </PageLayout>
  )
}
